import React from "react";

type ListingReviewsSectionHeaderContainer = React.ComponentProps<"div">;

export const ListingReviewsSectionHeaderContainer = ({
  children,
  ...props
}: ListingReviewsSectionHeaderContainer) => {
  return <div {...props}>{children}</div>;
};
